import { combineReducers } from 'redux';

export function error(state = null, action) {
    switch (action.type) {
        case 'SONG_SHOW_ERROR':
            return action.error;

        case 'SONG_SHOW_RESET':
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case 'SONG_SHOW_LOADING':
            return action.loading;

        case 'SONG_SHOW_RESET':
            return false;

        default:
            return state;
    }
}

export function retrieved(state = null, action) {
    switch (action.type) {
        case 'SONG_SHOW_RETRIEVED_SUCCESS':
            return action.retrieved;

        case 'SONG_SHOW_RESET':
            return null;

        default:
            return state;
    }
}

export function showChords(state = false, action) {
    switch (action.type) {
        case 'SONG_SHOW_CHORDS':
            return action.show;
        default:
            return state;
    }
}

export default combineReducers({ error, loading, retrieved, showChords });



// WEBPACK FOOTER //
// ./src/reducers/song/show.js